import { AxiosRequestConfig } from 'axios';
import { useQuery } from 'react-query';

import {
  getCostCenterGrantsByGroup,
  getGrants,
  getGrantsCatalog
} from 'RestAPIs/admin';

interface Props {
  options?: Record<string, unknown>;
  queryParams?: AxiosRequestConfig['params'];
}

export const useGetGrantsCatalog = ({ options, queryParams }: Props = {}) =>
  useQuery(
    ['grants-catalog'],
    async () => {
      const { data } = await getGrantsCatalog(queryParams);
      return data;
    },
    options
  );

export const useGetGrants = ({ options, queryParams }: Props) =>
  useQuery(
    ['grants', queryParams.groupId],
    async () => {
      const { data } = await getGrants(queryParams);
      return data;
    },
    options
  );

export const useGetCostCenterGrantsByGroup = (groupId: number) =>
  useQuery(['cost-center-grants', groupId], async () => {
    const { data } = await getCostCenterGrantsByGroup(groupId);
    return data;
  });
